import courseListPaginationUI from '../../templates/course_list/course_list_pagination.mustache';
import dig from '../util/dig';
import 'custom-event-polyfill';
import 'element-closest-polyfill';

/**
  * CourseListPagination class to manage client side interaction with the course list pagination
  * component
  *
  * @param {DOM element} this.target
  */
export default class CourseListPagination {
  constructor(target) {
    if (!target) { return; }

    this.target = target;
    this.currentPage = 1;
    this.totalPages = 1;
    //we need the arrow function expression syntax so that the eventhandler can access the class
    //using 'this'
    target.addEventListener('click', (event) => this._handleClickEvent(event));
  }

  /**
    * Builds the data structure for mustache rendering of the pagination for the course list
    *
    * @param {integer} current
    * @param {integer} total
    */
  _buildPageList(current, total) {
    const initialArray = Array.from({ length: total },
      (v, k) => ({ page: k + 1, isCurrent: current === k + 1 }));

    const placeHolder = [{ page: '...', isEllipsis: true }];

    if (total <= 7) {
      return initialArray;
    } else if (current <= 4) {
      return initialArray.slice(0, 5).concat(placeHolder).concat(initialArray.slice(-1));
    } else if (current > (total - 4)) {
      return initialArray.slice(0, 1).concat(placeHolder).concat(initialArray.slice(-5));
    } else {
      return initialArray.slice(0, 1)
        .concat(placeHolder)
        .concat({ page: current - 1, isCurrent: false })
        .concat({ page: current, isCurrent: true })
        .concat({ page: current + 1, isCurrent: false })
        .concat(placeHolder)
        .concat(initialArray.slice(-1));
    }
  }

  /**
    * Determines wether or not to raise a page event based
    * on the element that was clicked
    */
  _handleClickEvent(e) {
    const button = e.target.closest('button');
    if (button && button.classList.contains('pagination-item__page') &&
      !button.classList.contains('disabled')) {
      e.preventDefault();
      this._raisePageEvent(button);
    }
  }

  /**
    * Determines page action and raises custom event with page data
    *
    * @param {DOM element} button
    */
  _raisePageEvent(button) {
    let page = dig(['value'], button);
    const pageNum = Number(page);
    if (page === null) {
      return;
    } else if (page === 'prev' && this.currentPage > 0) {
      page = this.currentPage - 1;
    } else if (page === 'next' && this.currentPage < this.totalPages) {
      page = this.currentPage + 1;
    } else if (pageNum === 0) {
      page = 1;
    } else if (pageNum > 0) {
      page = pageNum;
    }

    const event = new CustomEvent('page', { detail: { page } });
    document.dispatchEvent(event);
  }

  /**
    * Renders pagination html
    *
    * @param {object} page information from elasticsearch
    */
  render({current, total_pages}) {
    if (!this.target) { return; }

    this.currentPage = current;
    this.totalPages = total_pages;
    const pageData = {
      current,
      total: total_pages,
      isFirst: current === 1,
      isLast: current === total_pages,
      pages: this._buildPageList(current, total_pages)
    };
    this.target.innerHTML = courseListPaginationUI(pageData);
  }

  /**
    * Clears the target element
    */
  clear() {
    if (!this.target) { return; }

    this.target.innerHTML = '';
  }
}

